import { render, staticRenderFns } from "./SpecializationPicker.vue?vue&type=template&id=8f5d7de6&"
import script from "./SpecializationPicker.vue?vue&type=script&lang=js&"
export * from "./SpecializationPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports